import { Component, computed, inject } from '@angular/core';
import { AuthService } from 'core';
import { BalanceSpecialUsersComponent } from '../balance-special-users/balance-special-users.component';
import { BalanceMembersComponent } from '../balance-members/balance-members.component';

@Component({
  selector: 'app-balance-root',
  imports: [BalanceSpecialUsersComponent, BalanceMembersComponent],
  templateUrl: './balance-root.component.html',
  styleUrl: './balance-root.component.scss'
})
export class BalanceRootComponent {
  readonly #authService = inject(AuthService);

  readonly currentUserIsSpecial = computed(() => {
    return this.#authService.currentUser$()?.isSpecial;
  });
}
